import React from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Accordion,
  Card,
  Button,
} from 'react-bootstrap';
import './SearchIndicationPage.scss';
import { SearchIndicationSVG } from '../../img/SearchIndicatorSVG';
const SearchIndicationPage = () => {
  return (
    <Container className="Search-Container pl-0">
      <Row className="Search-Row">
        <Col className="Search-Col">
          <SearchIndicationSVG />
        </Col>
      </Row>
      <Row className="Search-Row">
        <Col className="Search-Col">
          <div>Start typing &lt;Name,Tax ID, or Address&gt; to search</div>
        </Col>
        <Col>
          Enter a search criteria and apply filters for better search results.
        </Col>
      </Row>
    </Container>
  );
};
export default SearchIndicationPage;
